import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedDataService {
  public simulacionData: any = null;

  private simulacionDataSubject = new BehaviorSubject<any>(null);
  public simulacionData$ = this.simulacionDataSubject.asObservable();

  private chartInstitucionDataSubject = new BehaviorSubject<any>(null);
  public chartInstitucionData$ = this.chartInstitucionDataSubject.asObservable();

  private rutFilterSubject = new BehaviorSubject<string>('');
  public rutFilter$ = this.rutFilterSubject.asObservable();

  private nameFilterSubject = new BehaviorSubject<string>('');
  public nameFilter$ = this.nameFilterSubject.asObservable();


  setSimulacionData(simulacionData: any) {
    this.simulacionDataSubject.next(simulacionData);
  }

  getSimulacionData(): any {
    return this.simulacionDataSubject.getValue();
  } 

  setChartInstitucionData(chartInstitucionData: any) {
    this.chartInstitucionDataSubject.next(chartInstitucionData);
  }

  getChartInstitucionData(): any {
    return this.chartInstitucionDataSubject.getValue();
  }

  setRutFilter(rut: string) {
    this.rutFilterSubject.next(rut);
  }

  getRutFilter(): string {
    return this.rutFilterSubject.getValue();
  }

  setNameFilter(rut: string) {
    this.nameFilterSubject.next(rut);
  }

  getNameFilter(): string {
    return this.nameFilterSubject.getValue();
  }

}
